//import node_modules
import React, { FunctionComponent } from "react";
import Link from "next/link";
import { Pagination } from "react-bootstrap";

//hooks
import usePaginationContext from "../hooks/usePaginationContext";

const PaginationNextComponent: FunctionComponent = () => {
  const handler = usePaginationContext();

  if (handler.disabled(handler.getPageCount())) {
    return <Pagination.Next disabled={true} />;
  }

  return (
    <Link href={handler.generatePath(handler.getPage() + 1)}  legacyBehavior passHref>
      <Pagination.Next />
    </Link>
  );
};

export default React.memo(PaginationNextComponent);
